import {createSlice} from "@reduxjs/toolkit";
import {getBookingInsights} from "@/store/booking-insight/action";
import {bookingInsightType} from "@/pages/Report/constant";

const initialState = {
  state: {
    bookingTimes: null,
    bookingMethod: null,
    bookingCourt: null,
    bookingVenue: null
  },
  loading: true,
  error: ''
} as BaseState<BookingInsightState>

const slice = createSlice({
  name: 'bookingInsight',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // income summary
    builder.addCase(getBookingInsights.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getBookingInsights.fulfilled, (state, action) => {
      const { type, data } = action.payload
      const modifiedState = { ...state.state }

      switch (type) {
        case bookingInsightType.BOOKING_TIMES:
          modifiedState.bookingTimes = data.detail as BookingTimes
          break
        case bookingInsightType.BOOKING_METHOD:
          modifiedState.bookingMethod = data.detail as BookingMethod
          break
        case bookingInsightType.COURTS:
          modifiedState.bookingCourt = data.detail as BookingCourt
          break
        case bookingInsightType.VENUE:
          modifiedState.bookingVenue = data.detail as BookingVenue
          break
        default:
          break
      }
      
      return {
        ...state,
        state: modifiedState,
        loading: false,
        error: null
      }
    })
    builder.addCase(getBookingInsights.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get coupons, please try again'
    }))
  }
})

export default slice
